import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import moment, { months } from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from '../General/Utility';

const PrintManageSections = () => {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [SessionID, setSessionID] = useState(localStorage.getItem("DefaultSession"));
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [classID, setClassID] = useState();
    const [listOfLedger, setLedger] = useState([]);




    useEffect(() => {
        document.title = "List Of Sections"

        const urlParams = new URLSearchParams(window.location.search);


        let classId = urlParams.get('class_id');
        setClassID(classId);

        //console.log(classID);

        setLoading(true);


        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            PageNo: 1,
            PageSize: 1000,
            Class_Id: classId,
            SessionID: SessionID,
        };



        //console.log(data);
        var api_config = {
            method: 'post',
            url: config.base_url + 'Sections/GetAllSections',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        //console.log(data);

        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords);
                    setTotalRecords(response.data.totalRecords)
                    setLoading(false)
                }
                else {
                    setLedger(null);
                    setTotalRecords(0)
                }
            })
            .catch(function (error) {
                //console.log(error);
            });

    }, []);

    const renderLedger = () => {

        if (listOfLedger.length > 0) {
            let count = 1;

            return (
                listOfLedger.map((item, index) => {
                    return (
                        <tr key={index} >
                            <td>{count++}</td>
                            <td>{item.Section_ID}</td>
                            <td>{item.Section_Code}</td>
                            <td>{item.Section_Short_Name}</td>
                            <td>{item.Section_Name}</td>
                            <td>{item.Section_Strength_Limit}</td>
                            <td>{item.SelectedClass.Class_Name}</td>
                            <td>{item.Section_Teacher_Name}</td>

                        </tr>

                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colSpan="20"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }


    return (
        <>
            <Page orientation="potrait" size="a4">
                <table className="table table-sm table-bordered table-print">
                    <thead>
                        <tr>
                            <td colSpan="8">
                                <PrintHeader title={`List Of Sections`} />
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>

                            <th>
                                Sr#
                            </th>
                            <th>
                                Section ID
                            </th>
                            <th>
                                Section Code
                            </th>
                            <th>
                                Section Short Name
                            </th>
                            <th>
                                Section Name
                            </th>
                            <th>
                                Strength Limit
                            </th>
                            <th>
                                Class Name
                            </th>
                            <th>
                                Teacher Name
                            </th>
                        </tr>
                        {
                            loading ?
                                <tr>
                                    <td className="text-center" colSpan="5">
                                        <Spinner animation="border" role="status"></Spinner>
                                    </td>
                                </tr>
                                :
                                <>
                                    {renderLedger()}

                                </>

                        }

                    </tbody>
                </table>


            </Page>
        </>
    );
}

export default PrintManageSections;
